import { TagPassThroughOptions } from 'primevue';
import { PassThrough } from '@primevue/core';

export enum TagType {
  RISK_LEVEL = 'risk_level',
  PILL = 'pill',
  ADDITIONAL = 'additional',
  UNSTYLED = 'unstyled',
}

export enum TagStateRiskLevel {
  N_A = 'n/a',
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
  CRITICAL = 'critical',
}

export enum TagStatePill {
  DEFAULT = 'default',
}

export enum TagStateAdditional {
  PINK = 'pink',
  FUCHSIA = 'fuchsia',
  VIOLET = 'violet',
  INDIGO = 'indigo',
  BLUE = 'blue',
  SKY = 'sky',
  CYAN = 'cyan',
  TEAL = 'teal',
  EMERALD = 'emerald',
  LIME = 'lime',
  SLATE = 'slate',
  DARK_SLATE = 'dark_slate',
}

export enum TagIconPosition {
  LEFT = 'left',
  RIGHT = 'right',
}

export enum TagSize {
  BASE = 'base',
  SMALL = 'small',
}

export type TagRiskLevelProps = {
  type: `${TagType.RISK_LEVEL}`;
  state?: `${TagStateRiskLevel}`;
  icon_position?: `${TagIconPosition}`;
  icon?: string;
  label?: string;
  size?: `${TagSize}`;
  pt?: PassThrough<TagPassThroughOptions>;
};

export type TagPillProps = {
  type: `${TagType.PILL}`;
  state?: `${TagStatePill}`;
  label_left?: string;
  label_right?: string;
  size?: `${TagSize}`;
  pt_left?: PassThrough<TagPassThroughOptions>;
  pt_right?: PassThrough<TagPassThroughOptions>;
};

export type TagAdditionalProps = {
  type: `${TagType.ADDITIONAL}`;
  state?: `${TagStateAdditional}`;
  icon_position?: `${TagIconPosition}`;
  icon?: string;
  label?: string;
  size?: `${TagSize}`;
  pt?: PassThrough<TagPassThroughOptions>;
};

export type TagUnstyledProps = {
  type: `${TagType.UNSTYLED}`;
  icon_position?: `${TagIconPosition}`;
  icon?: string;
  label?: string;
  size?: `${TagSize}`;
  pt?: PassThrough<TagPassThroughOptions>;
};

export type TagProps =
  | TagRiskLevelProps
  | TagPillProps
  | TagAdditionalProps
  | TagUnstyledProps;
